import {  AxiosQUANTUM, quantumOrgId, quantumUserId  } from "../apiConfig";
// import { appendQueryParams } from "../../utilities/urlUtils";


export const orgId =  quantumOrgId;
export const userId =  quantumUserId;

export const approval = {

  $_getPrivileges() {
    // let url = "/dashboard/get-all-modules";
    let url = "/apps/muleex/privileges";
    return AxiosQUANTUM.get(url);
  },
  $_getRolePrivileges(roleId) {
    let url = `/roles/${roleId}/privileges`;
    return AxiosQUANTUM.get(url);
  },
  $_createRole(payload) {
    let url = "/roles";
    payload.orgId = orgId();
    return AxiosQUANTUM.post(url, payload);
  },
  $_getRoles() {
    let url = `/roles/${orgId()}/muleex`;
    return AxiosQUANTUM.get(url);
  },
  $_getRoleAndItsPrivileges(roleId) {
    let url = `/roles/${roleId}/privileges`;
    return AxiosQUANTUM.get(url);
  },
  $_getRoleAndItsUsers(roleId) {
    let url = `/org/${orgId()}/users?app=muleex&roleId=${roleId}`;
    return AxiosQUANTUM.get(url);
  },
  $_deleteRole(roleId) {
    let url = `/roles/${roleId}`;
    return AxiosQUANTUM.delete(url);
  },

  $_updateRole(payload) {
    let url = "/roles";
    return AxiosQUANTUM.patch(url, payload);
  },
};
